/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { PreviewType, UnifiedCollectionType } from 'client-code/previews';

/**
 * ContentTitle displays the title for a series or movie.
 * For movies, it appends the release year in parentheses.
 * If the title is not available, displays "TITLE_NOT_AVAILABLE".
 * @param title - The content title string.
 * @param year - The release year (for movies).
 * @param showType - The type of content (series or movie).
 * @param leagueName - The league name (for teams and leagues) if available.
 */
const ContentTitle: FunctionComponent<{
    postfixTitle?: string;
    showType?: string;
    title?: string;
    year?: number;
}> = ({ title, year, showType, postfixTitle }) => {
    const isTeamOrLeague =
        showType === UnifiedCollectionType.TeamPreview ||
        showType === UnifiedCollectionType.LeaguePreview;
    return (
        <React.Fragment>
            <div className="uikit primary-text-style text-size-xlarge">
                {title || 'TITLE_NOT_AVAILABLE'}
                {showType === PreviewType.MoviePreview && year ? ` (${year})` : null}
                {isTeamOrLeague && postfixTitle ? ` (${postfixTitle})` : null}
            </div>
        </React.Fragment>
    );
};

export default ContentTitle;
